import RadioButton from 'components/shared/RadioButton';
import { useState } from 'react';
import { StyledContent, StyledSwitcher } from './Switcher.styled';
import { SwitcherProps } from './Switcher.types';

const Switcher: React.FC<SwitcherProps> = ({ tabsName, tabs, label }) => {
  const defaultTabChecked = tabs.findIndex(
    (tab) => tab.defaultChecked === true
  );

  const defaultTabCheckedPosition =
    defaultTabChecked >= 0 ? defaultTabChecked : 0;

  const [activeTab, setActiveTab] = useState(
    tabs[defaultTabCheckedPosition].id
  );

  return (
    <div>
      <StyledSwitcher role="tablist">
        {label && <legend>{label}</legend>}
        {tabs.map((tab, index) => (
          <RadioButton
            key={index}
            name={tabsName}
            id={tab.id}
            label={tab.label}
            aria-controls={tab.id + '_content'}
            aria-selected={activeTab === tab.id}
            onChange={() => setActiveTab(tab.id)}
            checked={activeTab === tab.id}
          />
        ))}
      </StyledSwitcher>
      {tabs.map((tab, index) => (
        <StyledContent
          key={index}
          id={tab.id + '_content'}
          role="tabpanel"
          aria-labelledby={tab.id}
          className={activeTab === tab.id ? 'is-active' : ''}
        >
          {tab.content}
        </StyledContent>
      ))}
    </div>
  );
};

export default Switcher;
